export const INTERFACE_KEY = {
  CONTENTS_COVER_LEVEL: "ContentsCoverLevel",
  EXCESS_CONTENTS: "ExcessContents",
  NO_CLAIMS_CONTENTS: "NoClaimsContents",
  LEGAL_EXPENSES: "LegalExpenses",
  SPECIFIED_ITEM_TYPE: "SpecifiedItemType",
  SPECIFIED_ITEM_DESCRIPTION: "SpecifiedItemDescription",
  SPECIFIED_ITEM_VALUE: "SpecifiedItemValue",
  PP_ITEM_TYPE: "PPItemType",
  PP_ITEM_DESCRIPTION: "PPItemDescription",
  PP_ITEM_VALUE: "PPItemValue",
  TERM_OF_INSURANCE: "TermOfInsurance",
  PAYMENT_FREQUENCY: "PaymentFrequency",
  COVER_TYPE: "CoverType",
  DISABILITY_QUALIFICATION_TYPE: "QualTypeDisability",
  DISABILITY_QUALIFICATION_PERIOD: "QualPeriodDisability",
  UNEMPLOYMENT_QUALIFICATION_TYPE: "QualTypeUnemployment",
  UNEMPLOYMENT_QUALIFICATION_PERIOD: "QualPeriodUnemployment",
  BENEFIT_PERIOD: "PolicyBenefitPeriod",
};

export const SPECIFIED_ITEM_KEYS = [
  INTERFACE_KEY.SPECIFIED_ITEM_TYPE,
  INTERFACE_KEY.SPECIFIED_ITEM_DESCRIPTION,
  INTERFACE_KEY.SPECIFIED_ITEM_VALUE,
];

export const PP_ITEM_KEYS = [
  INTERFACE_KEY.PP_ITEM_TYPE,
  INTERFACE_KEY.PP_ITEM_DESCRIPTION,
  INTERFACE_KEY.PP_ITEM_VALUE,
];

export const PAYMENT_FREQUENCY_VALUE = {
  ANNUAL: "Annual",
  MONTHLY: "Monthly",
};

export const TERM_OF_INSURANCE_VALUE = {
  SixMonths: "6 months",
  TwelveMonths: "12 months",
};

export const MPPI_QUAL_TYPE_OPTIONS = [
  {
    text: "Back to Day 1",
    value: "DayOne",
  },
  {
    text: "Excess",
    value: "Excess",
  },
];

export const MPPI_QUAL_PERIOD_OPTIONS = [
  {
    text: "30 days",
    value: "ThirtyDays",
  },
  {
    text: "60 days",
    value: "SixtyDays",
  },
  {
    text: "180 days",
    value: "OneHundredEightyDays",
  },
];

export const MPPI_POLICY_BENEFIT_PERIOD_OPTIONS = [
  {
    text: "12 months",
    value: "TwelveMonths",
  },
  {
    text: "24 months",
    value: "TwentyFourMonths",
  },
];

export const MPPI_COVER_TYPE_OPTIONS = [
  {
    text: "Accident and sickness",
    value: "Disability",
  },
  {
    text: "Accident, sickness and unemployment",
    value: "UnemploymentAndDisability",
  },
];

export const ANSWER_SOURCES = {
  THIRD_PARTY: "ThirdParty",
};
